export default import.meta.ROLLDOWN_FILE_URL_gPqrKKxmu_ftAVkCV3XzNw